/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import {
  CrmCustomerDTO,
  CustomerSummaryVoModel,
  CustomerDetailMeta,
  CustomerVO,
  CustomerListMeta,
  CustomerListModel,
} from '@well/domain';

@Injectable({
  providedIn: 'root',
})
export class CustomerResourceService extends AbstractResourceService<
  CustomerListModel,
  CrmCustomerDTO,
  CustomerListMeta,
  CustomerDetailMeta
> {
  constructor(httpClient: HttpClient, @Optional() environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('customerUrl'), CustomerListModel, CrmCustomerDTO);
  }

  findCustomerSummaryVos(
    query?: any,
    additionalParams?: any
  ): Observable<JsonApiResource<CustomerSummaryVoModel[], JsonApiListResourceMetadataBase>> {
    const queryString = new QueryParams(query, additionalParams ? additionalParams : []).toString();
    return this.httpClient
      ?.get<JsonApiResource<CustomerSummaryVoModel[], JsonApiListResourceMetadataBase>>(
        `${this.url}` + '/vo/customerSummaryVos' + `${queryString}`
      )
      .pipe(
        map((jsonApiResource) => {
          jsonApiResource.data = jsonApiResource.data.map((item) =>
            AbstractResourceService.resourceMapper(CustomerSummaryVoModel, item)
          );
          jsonApiResource.meta = AbstractResourceService.resourceMapper(
            JsonApiListResourceMetadataBase,
            jsonApiResource.meta
          );
          return jsonApiResource;
        })
      );
  }

  getInformation(uuid: string): Observable<CustomerVO> {
    return <Observable<CustomerVO>>this.httpClient?.get(`${this.url}/information/${uuid}`);
  }
}
